<template>
  <v-form
    ref="form"
    lazy-validation>
    <v-container
      py-0
      fill-height
      fluid
      grid-list-xl>
      <v-layout wrap>
        <v-flex
          xs12
          md4>
          <MaglinkComponentTankList
            :loading="progressBar.loading"
            :filters="filters"
            :tanks="tanks"
            data-testId="MaglinkComponentTankList" />
        </v-flex>
        <v-flex
          xs12
          md2>
          <v-switch
            v-model="filters.all"
            :disabled="progressBar.loading"
            :label="`${$t('All tanks')}`"
            class="dover-input"/>
        </v-flex>
        <v-flex
          xs6
          md1
          text-xs-left>
          <v-btn
            small
            class="mx-0 font-weight-light"
            color="dover-blue"
            @click="onApplyFilter">
            {{ $t('Load') }}
          </v-btn>
        </v-flex>
        <v-flex
          xs6
          md2
          text-xs-right>
          <MaglinkComponentCsvExportButton
            :loading="progressBar.loading"
            @csvExport="onCsvExport" />
        </v-flex>
        <v-flex
          xs12
          md12
          lg12>
          <MaglinkComponentLoadingBar
            :loading="progressBar.loading"
            :indeterminate="false"
            :max-value="progressBar.maxValue"
            :value="progressBar.currentValue" />
          <span>{{ itemCountLabel }}</span>
          <hr>
        </v-flex>
        <v-flex
          xs12
          md12
          lg12
          text-xs-left>
          <span
            class="grey--text font-weight-bold">
            {{ tankDescription }}
          </span>
        </v-flex>
        <v-flex
          xs12
          md12>
          <v-data-table
            :headers="headers"
            :items="dataSource"
            :no-data-text="`${ Maglink.NoDataMessage(false) }`"
            :no-results-text="`${ Maglink.NoDataMessage(true) }`"
            hide-actions>
            <template
              slot="headerCell"
              slot-scope="{ header }">
              <span
                class="dover-light-blue-color"
                v-text="header.text" />
            </template>
            <template
              slot="items"
              slot-scope="{ index, item }">
              <tr
                :style="{backgroundColor: ((index % 2 === 0) ? '#cfdbfb' : 'transparent' ) }"
                class="text-xs-left">
                <td class="text-xs-right">{{ item.tankNumber }}</td>
                <td class="text-xs-center">{{ item.tankDescription }}</td>
                <td class="text-xs-center">{{ Maglink.GetCustomDateTime(item.measuredOn, systemSettings.dateFormat) }}</td>
                <td class="text-xs-right">{{ item.productLevel }}</td>
                <td class="text-xs-right">{{ item.productVolume }}</td>
                <td class="text-xs-right">{{ item.productVolumeComp }}</td>
                <td class="text-xs-right">{{ item.waterLevel }}</td>
                <td class="text-xs-right">{{ item.waterVolume }}</td>
                <td class="text-xs-right">{{ item.temperature }}</td>
                <td class="text-xs-right">{{ item.weight }}</td>
                <td class="text-xs-right">{{ item.ullage }}</td>
                <td class="text-xs-left">{{ Maglink.GetStatusInfo(item.tankStatus).statusDesc }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
export default {
  props: {
    systemSettings: {
      type: Object,
      required: true,
      default: () => { }
    },
    options: {
      type: Object,
      required: true,
      default: () => { }
    },
    siteInfo: {
      type: Object,
      required: true,
      default: () => { }
    },
    tanks: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data: () => ({
    progressBar: {
      loading: false,
      maxValue: 100,
      currentValue: 0
    },
    headers: [],
    dataSource: [],
    filters: {
      all: false,
      number: 1,
      type: 0,
      fromDay: '',
      toDay: ''
    },
    levelUdm: '',
    volUdm: '',
    tempUdm: ''
  }),
  mounted () {
    this.levelUdm = this.options.levelUnits[this.systemSettings.levelUnit || 0].desc
    this.volUdm = this.options.volumeUnits[this.systemSettings.volumeUnit || 0].desc
    this.tempUdm = this.options.temperatureUnits.find(c => c.code === this.systemSettings.temperatureUnit).desc

    this.headers = [
      { sortable: false, text: this.$t('Tank'), align: 'right' },
      { sortable: false, text: this.$t('Description'), align: 'center' },
      { sortable: false, text: this.$t('Time'), align: 'center' },
      { sortable: false, text: this.$t('Level') + ' (' + this.levelUdm + ')', align: 'right' },
      { sortable: false, text: this.$t('Volume') + ' (' + this.volUdm + ')', align: 'right' },
      { sortable: false, text: this.$t('TC volume') + ' (' + this.volUdm + ')', align: 'right' },
      { sortable: false, text: this.$t('Water level') + ' (' + this.levelUdm + ')', align: 'right' },
      { sortable: false, text: this.$t('Water vol') + ' (' + this.volUdm + ')', align: 'right' },
      { sortable: false, text: this.$t('Temperature') + ' (' + this.tempUdm + ')', align: 'right' },
      { sortable: false, text: this.$t('Weight') + ' (' + this.$t('Kg') + ')', align: 'right' },
      { sortable: false, text: this.$t('Ullage') + ' (' + this.volUdm + ')', align: 'right' },
      { sortable: false, text: this.$t('Status'), align: 'center' }
    ]

    this.onApplyFilter()
  },
  methods: {
    getDataSource () {
      this.dataSource = []
      this.progressBar.loading = true

      if (this.filters.all === false) {
        // Get single tank
        const tank = this.filters.number * 1
        this.Maglink.GetTankStatus(tank)
          .then(response => {
            this.handleResponse([response.data])
          })
          .catch(error => {
            this.progressBar.loading = false
            this.snack('error', error.message)
          })
      } else {
        // Get all tanks
        this.Maglink.GetTanks()
          .then(response => this.handleResponse(response.data))
          .catch(error => {
            this.progressBar.loading = false
            this.snack('error', error.message)
          })
      }
    },
    handleResponse (data) {
      this.progressBar.loading = true
      let total = data.length
      this.progressBar.maxValue = total

      for (let i = 0; i < data.length; i++) {
        this.progressBar.currentValue = i
        const line = { ...data[i].lastMeasurement, tankDescription: data[i].tankDescription }
        this.dataSource.push(this.Maglink.ToDisplay(line, this.systemSettings.levelUnit, this.systemSettings.volumeUnit, this.systemSettings.temperatureUnit))
      }

      this.progressBar.loading = false
    },
    getHeadearsToExport (type, sep) {
      if (type === 0) {
        return ''
      }
      let fileContent = ''
      for (let index = 0; index < this.headers.length; index++) {
        fileContent += this.headers[index].text + sep
      }
      fileContent += '\n'

      return fileContent
    },
    onApplyFilter () {
      this.getDataSource()
    },
    onCsvExport (sep) {
      let fileContent = ''
      let title = ''

      if (this.siteInfo.name) {
        fileContent += this.siteInfo.name + '\n'
      }
      if (this.siteInfo.header1) {
        fileContent += this.siteInfo.header1 + '\n'
      }
      if (this.siteInfo.header2) {
        fileContent += this.siteInfo.header2 + '\n'
      }
      if (this.siteInfo.header3) {
        fileContent += this.siteInfo.header3 + '\n'
      }

      // filter
      if (this.filters.all) {
        title = this.$t('All tanks')
        fileContent += title + '\n'
      } else {
        title = this.$t('Tank {0}', [ this.filters.number ])
        fileContent += title + sep
        fileContent += this.tanks[this.filters.number - 1].tankDescription + '\n'
      }

      for (let index = 0; index < this.headers.length; index++) {
        fileContent += this.headers[index].text + sep
      }
      fileContent += '\n'

      for (let index = 0; index < this.dataSource.length; index++) {
        let t = this.dataSource[index]
        fileContent += t.tankNumber + sep
        fileContent += t.tankDescription + sep
        fileContent += this.Maglink.GetCustomDateTime(t.measuredOn, this.systemSettings.dateFormat).substr(0, 16) + sep
        fileContent += t.productLevel + sep
        fileContent += t.productVolume + sep
        fileContent += t.productVolumeComp + sep
        fileContent += t.waterLevel + sep
        fileContent += t.waterVolume + sep
        fileContent += this.Maglink.TemperatureFormat(this.Maglink.TemperatureToDisplay(t.temperature, this.systemSettings.temperatureUnit)) + sep
        fileContent += t.weight + sep
        fileContent += t.ullage + sep
        fileContent += this.Maglink.GetStatusInfo(t.tankStatus).statusDesc + '\n'
      }

      let filename = this.$t('Inventory report') + '__' + title + '__' + this.Maglink.GetCurrentDate() + '.csv'
      const link = this.Maglink.GetDownloadLinkCSV(fileContent, filename)
      document.body.appendChild(link)
      link.click()
    },

    snack (color, message) {
      message = this.$t('Inventory') + ': ' + message
      this.$store.dispatch('showSnackbar', { color, message, show: true })
    }
  }
}
</script>
